import styled from 'styled-components';

export const UserStatusWithdrawalLimitsToggleStyled = styled.div`
    padding: 16px;
    background: var(--color-background-secondary);
    box-shadow: var(--shadow-primary);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 16px;
    position: relative;
    
    &.disabled {
        opacity: 0.5;
    }
`;

export const UserStatusWithdrawalLimitsToggleInfoStyled = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    min-height: 68px;
    color: var(--color-label-secondary);
    font-size: 14px;
    
    .unlimited-amount {
        font-size: 20px;
    }
`;

export const UserStatusWithdrawalLimitsToggleCardIconWrapperStyled = styled.div`
    color: var(--color-fill-secondary);
    position: absolute;
    top: 0;
    right: 8px;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const UserStatusWithdrawalLimitsToggleTitleContainerStyled = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 4px;
`;
